module.exports = __webpack_public_path__ + "static/media/desktopScreenshot01.abf80275.jpg";